import moment from 'moment';
import { WeekDay } from '@app-types/index';
import { TimeSlotConfigurationModelType } from '@models/TimeSlotConfiguration';
import { weekDays } from '@data/weekDays';
import { initialTimeSlotConfigurationValues, TimeSlotConfigurationsDataType } from '@modules/timetable';

/**
 * Get general time slot configurations
 * @param timeSlotConfigurations
 */
export const getGeneralTimeslotConfigurations = (
  timeSlotConfigurations: TimeSlotConfigurationModelType[],
): TimeSlotConfigurationsDataType => {
  const timeSlotConfigurationDefaultValues: TimeSlotConfigurationsDataType = {
    ...initialTimeSlotConfigurationValues,
  };

  weekDays.forEach((weekDay, index) => {
    const configurationsForWeekDay = timeSlotConfigurations.filter(
      (timeSlotConfiguration) => moment(timeSlotConfiguration.startTime).weekday() === index,
    );

    if (configurationsForWeekDay.length > 0) {
      timeSlotConfigurationDefaultValues[WeekDay[weekDay as WeekDay]] = configurationsForWeekDay.map(
        (configuration) => ({
          startTime: moment(configuration.startTime),
          endTime: moment(configuration.endTime),
          interval: false,
        }),
      );
    }
  });

  return timeSlotConfigurationDefaultValues;
};
